// 全局头部区域
import React, { useState, useEffect, useContext } from 'react';
import { Dropdown, Layout, Avatar, Button, Tooltip } from 'antd';
import { LeftOutlined, CloseOutlined, HomeOutlined, MenuOutlined, UserOutlined, MessageOutlined } from '@ant-design/icons';
import DesktopNavigationContext from '@/components/desktopnavigation/context';
import NotificationBadge from '@/components/notifications';
import logo from '@/assets/logo.png'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import { useSelector } from 'react-redux';
import { usePersonalNavigationItems } from '@/components/personalnavigation';

const { Header } = Layout;

const MainHeader = ({ shell = false }) => {
  // 配置初始化
  const navigate = useNavigate();
  const navigation = useContext(DesktopNavigationContext);
  const { pathname: routePath } = useLocation();
  const pathname = routePath.replace(/\/+$/, '') || '/';
  const { isAuthenticated, userInfo } = useSelector(state => state.user);
  const { items: personalItems } = usePersonalNavigationItems();
  const [avatarMenuOpen, setAvatarMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  useEffect(() => { setAvatarMenuOpen(false); }, [pathname, isAuthenticated, userInfo?.id]);
  // 根据页面宽度响应式调整判断是否为移动端样式
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    // 添加事件监听
    window.addEventListener('resize', handleResize);

    // 清理监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // 桌面由导航容器统一渲染固定头部，页面保留移动端原有头部。
  if (navigation && !shell && !isMobile) return null;

  // 常用页面与个人中心复用同一组入口及图标，退出登录也使用原处理逻辑。
  const shortcutPaths = ['/personal/info', '/personal/myposts', '/personal/favorites', '/personal/applications'];
  const managementPaths = ['/personal/admin', '/personal/report-management', '/personal/statistics', '/personal/audit'];
  const personalLinks = personalItems.flatMap(item => item.children || []);
  // 只复用权限校验后已经可见的管理入口，不凭本地角色单独放开菜单。
  const managementLinks = managementPaths.map(path => personalLinks.find(item => item.key === path)).filter(Boolean)
    .map(item => item.key === '/personal/admin' ? { ...item, label: <Link to={item.key}>用户管理</Link> } : item);
  const avatarSelectedKey = [...shortcutPaths, ...managementLinks.map(item => item.key)]
    .find(path => pathname === path || pathname.startsWith(`${path}/`));
  const dropdownItems = [
    ...shortcutPaths.map(path => personalLinks.find(item => item.key === path)).filter(Boolean),
    ...(managementLinks.length ? [{ key: 'management-shortcuts-divider', type: 'divider' }, ...managementLinks] : []),
    { key: 'quick-links-divider', type: 'divider' },
    ...personalItems.filter(item => item.key === 'logout'),
  ];

  return (
    // 全局头部区域
    <Header className={`mainheader${shell ? ' mainheader-shell' : ''}`}>
      <div className="mainheader-brand">
        {navigation?.isCollapsed && <Button className="mainheader-nav-toggle" type="text"
          icon={navigation.open ? <CloseOutlined /> : <MenuOutlined />}
          aria-label={navigation.open ? '收起侧边栏' : '展开侧边栏'} aria-expanded={navigation.open}
          aria-controls="desktop-navigation-drawer" onClick={navigation.toggle} />}
        {/* 左侧logo区域 */}
        <div className="demo-logo">
          <Link to="/">
            <Tooltip title="点击返回首页">
              <img src={logo} alt="" height={64} />
            </Tooltip>
          </Link>
        </div>
      </div>
      {!isMobile && <nav className="mainheader-navigation" aria-label="一级导航">
        {navigation?.returnLink && <Link className="mainheader-back" to={navigation.returnLink.path}><LeftOutlined /><span>{navigation.returnLink.label}</span></Link>}
        <Link to="/" aria-current={pathname === '/' ? 'page' : undefined}><HomeOutlined /><span>首页</span></Link>
        <Link to="/message" aria-current={pathname === '/message' || pathname.startsWith('/message/') ? 'page' : undefined}><MessageOutlined /><NotificationBadge><span>消息</span></NotificationBadge></Link>
        <Link to="/personal" aria-current={pathname === '/personal' || pathname.startsWith('/personal/') ? 'page' : undefined}><UserOutlined /><span>个人中心</span></Link>
      </nav>}
      {/* 右侧登录注册和用户下拉菜单选项，若为移动端则不渲染 */}
      {!isMobile && (isAuthenticated ? (
        // 已登录时显示用户头像及下拉菜单选项
        <div className="header-avatar" >
          <Dropdown menu={{ items: dropdownItems, selectedKeys: avatarSelectedKey ? [avatarSelectedKey] : [], 'aria-label': '用户菜单', onClick: () => setAvatarMenuOpen(false) }}
            open={avatarMenuOpen} onOpenChange={setAvatarMenuOpen} trigger={['click']} placement="bottomRight" arrow={{ pointAtCenter: true }}>
            <Button className="header-avatar-trigger" type="text" shape="circle" aria-label="打开用户菜单" aria-haspopup="menu" aria-expanded={avatarMenuOpen}>
              <Avatar size='large' src={userInfo?.avatar || undefined} icon={<UserOutlined />} />
            </Button>
          </Dropdown>
        </div>
      ) : (
        // 为登录时提示用户登录和注册
        <div className="header-login">
          <Button type="link" onClick={() => navigate('/login')}>登录</Button>|
          <Button type="link" onClick={() => navigate('/register')}>注册</Button>
        </div>
      ))}
    </Header>
  )
}

export default MainHeader;
